<template>
  <div>
    <center-nav></center-nav>
    <slider-menu :menuData="menuDataBasic" :type="2" v-if="isBasic"></slider-menu>
    <slider-menu :menuData="menuData" :type="2" v-else></slider-menu>
  </div>
</template>

<script>
import { getIsBasic, getHasPackage } from '@/utils/auth'
import centerNav from "../../../components/centerNav";
import sliderMenu from "@/components/SliderMenu";

export default {
  components: {
    sliderMenu, // 侧边栏
    centerNav, // 头部导航
  },
  data() {
    return {
      menuDataBasic: [
        {
          path: "/pc/official/statistics",
          icon: "icon-gzh_refresh_home_n_1",
          title: "主页",
          iconSize: '16px'
        },
        {
          path: "/pc/official/member",
          icon: "icon-gzh_refresh_list_n_2",
          title: "会员列表",
          iconSize: '16px'
        },
        {
          path: "/pc/official/order",
          icon: "icon-gzh_refresh_order_n_3",
          title: "推广订单",
          iconSize: '16px'
        },
        {
          path: "/pc/official/sort",
          icon: "icon-gzh_refresh_ranking_n_4",
          title: "会员排名",
          iconSize: '16px'
        },
        {
          path: "/pc/official/authorization",
          icon: "icon-gzh_refresh_accredit_n_8",
          title: "公众号授权",
          iconSize: '16px'
        },
        {
          path: "/pc/official/dialog",
          icon: "icon-gzh_refresh_renew_n_9",
          title: "激活续费",
          iconSize: '16px'
        },
        {
          path: "/pc/official/withdraw",
          icon: "icon-gzh_refresh_records_n_7",
          title: "提现记录",
          iconSize: '16px'
        },
        {
          path: "/pc/official/set",
          icon: "icon-gzh_refresh_set_n_10",
          title: "设置",
          iconSize: '16px'
        },
        {
          path: "/pc/official/invite",
          icon: "icon-gzh_refresh_website_n_11",
          title: "网站推广",
          iconSize: '16px'
        }
      ],
      menuData:
        [
          {
            path: "/pc/official/statistics",
            icon: "icon-gzh_refresh_home_n_1",
            title: "主页",
            iconSize: '16px'
          },
          {
            path: "/pc/official/member",
            icon: "icon-gzh_refresh_list_n_2",
            title: "会员列表",
            iconSize: '16px'
          },
          {
            path: "/pc/official/order",
            icon: "icon-gzh_refresh_order_n_3",
            title: "推广订单",
            iconSize: '16px'
          },
          {
            path: "/pc/official/sort",
            icon: "icon-gzh_refresh_ranking_n_4",
            title: "会员排名",
            iconSize: '16px'
          },
          {
            path: "/pc/official/mingxi",
            icon: "icon-gzh_refresh_detail_n_5",
            title: "佣金明细",
            iconSize: '16px'
          },
          {
            path: "/pc/official/commission",
            icon: "icon-gzh_refresh_examine_n_6",
            title: "佣金提现审核",
            iconSize: '16px'
          },
          {
            path: "/pc/official/withdraw",
            icon: "icon-gzh_refresh_records_n_7",
            title: "我的提现记录",
            iconSize: '16px'
          },
          {
            path: "/pc/official/authorization",
            icon: "icon-gzh_refresh_accredit_n_8",
            title: "公众号授权",
            iconSize: '16px'
          },
          {
            path: "/pc/official/dialog",
            icon: "icon-gzh_refresh_renew_n_9",
            title: "激活续费",
            iconSize: '16px'
          },
          {
            path: "/pc/official/set",
            icon: "icon-gzh_refresh_set_n_10",
            title: "基本设置",
            iconSize: '16px'
          },
          {
            path: "/pc/official/invite",
            icon: "icon-gzh_refresh_website_n_11",
            title: "网站推广",
            iconSize: '16px'
          },
        ]
    }
  },
  computed: {
    // 是否是基础版本的
    isBasic() {
      return getIsBasic() === 'true'
    },
    // 是否购买了公众号套餐
    hasPackage() {
      return getHasPackage() === 'true'
    }

  },
  watch: {
    $route: {
      // 监听路由变化
      deep: true,
      immediate: true,
      handler() {
        console.log(this.hasPackage, 'hasPackage')
        // 没有公众号回到购买订单
        if (!this.hasPackage) {
          this.$router.push('/pc/official/dialog')
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/pc/official/Index.vue